import { useMutation } from '@tanstack/react-query'
import { axiosPatch } from 'Redux/axiosHelper'
import { EventStep6Payload } from 'types/event/eventStep5'

const eventStep6 = async ({
  payload,
  eventId,
}: {
  payload: EventStep6Payload
  eventId: string
}) => {
  const response = await axiosPatch(
    payload,
    `v1/organization-events/${eventId}/event-step6`,
  )
  return response.data
}

export const useEventStep6 = () => {
  return useMutation(eventStep6)
}
